import React from 'react';
import { Modal, Paper } from '@mui/material';
import EditUserLayout from '../layouts/EditUserLayout';

function NewUserModal(props: {
    isOpen: boolean,
    onClose: Function,
    onSubmit: Function,
}) {
    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: 'absolute',
                    width: '600px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: 2
                }}
            >
                <EditUserLayout
                    title="Create User"
                    onCancel={() => props.onClose()}
                    onSubmit={props.onSubmit}
                />
            </Paper>
        </Modal>
    );
}

export default NewUserModal;